// @flow
import { ConstantsImport } from '../constants/ConstantsImport'
import { requestCommon } from 'live/lib/utils'
import { webConfig } from '../types/webConfig'
import { ResponseImport } from '../types/ResponseImport'

export class ProviderImport {
    idConfig = null
    requestOption = { ...requestCommon, method: 'GET' }
    importConfig = ConstantsImport.import.config

    setRequestOptions(webConfig: webConfig) {
        this.idConfig = webConfig.id
    }

    getWebExtensionInstances() {
        return fetch(
            this.importConfig.baseUrl + this.importConfig.read,
            this.requestOption
        ).then((res: ResponseImport) => res.json())
    }

    getWells = () => {
        return fetch(
            this.importConfig.baseUrl +
            this.importConfig.importPart +
            this.queryParams({ idConfig: this.idConfig, path: ConstantsImport.import.well.list, formatTree: true }),
            this.requestOption
        )
            .then(res => res.json())
            .then(this.handleResponse)
    }

    getByUrl = (url: string) => {
        return fetch(
            this.importConfig.baseUrl +
            this.importConfig.importPart +
            this.queryParams({ idConfig: this.idConfig, path: url.split('/api/public/')[1], formatTree: true }),
            this.requestOption
        )
            .then(res => res.json())
            .then(this.handleResponse)
    }

    getByFileType = (fileType: string, formatTree: boolean) => {
        return fetch(
            this.importConfig.baseUrl +
            this.importConfig.importPart +
            this.queryParams({ idConfig: this.idConfig, path: this.importConfig.fileType + fileType, formatTree, formatTree: true }),
            this.requestOption
        )
            .then(res => res.json())
            .then(this.handleResponse)
    }

    getAttachment = (fileId: string, fileRevision: string) => {
        return fetch(
            this.importConfig.baseUrl +
            this.importConfig.attachment +
            this.queryParams({ idConfig: this.idConfig, fileId, fileRevision }),
            this.requestOption
        )
            .then(res => res.json())
    }

    queryParams = (params: Object) => {
        return (
            '?' +
            Object.keys(params)
                .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
                .join('&')
        )
    }

    handleResponse = (res: ResponseImport) => {
        if (res.response === '') {
            throw res
        }
        let parsed
        try {
            parsed = JSON.parse(res.response)
        } catch (error) {
            throw new Error(error)
        }
        return parsed
    }
}
